import { useState } from "react";
import { Search, ShoppingBag } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import SearchOverlay from "@/components/SearchOverlay";

const LINKS = [
  { label: "Shop", href: "#shop", testid: "nav-link-shop" },
  { label: "Manifesto", href: "#manifesto", testid: "nav-link-manifesto" },
];

export default function Nav() {
  const { count, setOpen } = useCart();
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goTo = (e, href) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate(`/${href}`);
      return;
    }
    if (window.__lenis) {
      window.__lenis.scrollTo(href, { offset: -64, duration: 1.4 });
    } else {
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <header
        data-testid="site-nav"
      className="fixed inset-x-0 top-0 z-40 border-b border-line/60 bg-bone md:bg-bone/80 md:backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 md:px-12">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => goTo(e, "#top")}
          className="transition-transform duration-500 hover:-rotate-2 hover:scale-105"
        >
          <img
            src="/logo.png"
            alt="Easy Mood — home"
            className="h-10 w-auto"
          />
        </a>
        <nav className="flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              onClick={(e) => goTo(e, l.href)}
              className="relative hidden text-xs uppercase tracking-[0.2em] text-smoke transition-colors duration-300 after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-ink after:transition-[width] after:duration-300 hover:text-ink hover:after:w-full sm:block"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="nav-search-button"
            onClick={() => setSearchOpen(true)}
            aria-label="Search products"
            className="text-ink transition-colors duration-300 hover:text-ember"
          >
            <Search className="h-4 w-4" strokeWidth={1.5} />
          </button>
          <button
            data-testid="nav-cart-button"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:text-clay"
          >
            <ShoppingBag className="h-4 w-4" strokeWidth={1.5} />
            <span className="hidden sm:inline">Bag</span>
            {count > 0 && (
              <span
                data-testid="nav-cart-count"
                className="flex h-5 w-5 items-center justify-center rounded-full bg-ember text-[10px] tracking-normal text-ink"
              >
                {count}
              </span>
            )}
          </button>
        </nav>
      </div>
      </header>
      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}
